
import { Component, Ref, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

import Generic from '../../types/app/generic/generic';
import Endpoint from '../../utils/endpoint';

import CommandsComponent from '../../components/generics/Commands.vue';

@Component({
  components: {
    CommandsComponent: CommandsComponent,
  },
})
export default class Jurisdiction extends Vue {
  endpoint = new Endpoint();
  @Action('setSnackbar', { namespace: 'app' }) setSnackbar!: any;

  valid = null;
  saving = false;
  loading = false;
  rules = [
    v => !!v || 'This field is required',
    //v => (v && v.length <= 10) || 'Name must be less than 10 characters'
  ];
  isCreate = true;

  jurisdiction: Generic = {
    name: '',
    shortName: '',
    active: true,
  };

  async created() {
    this.isCreate = !this.$route.params.id;
    if (!this.isCreate) {
      this.loading = true;
      await this.getJurisdiction();
    }
  }

  get title(): string {
    return this.isCreate ? 'Create Jurisdiction' : 'Jurisdiction Detail';
  }

  async getJurisdiction(): Promise<void> {
    this.loading = true;
    const response = await this.$http.get(
      `${this.endpoint.jurisdiction.getById}/${this.$route.params.id}`
    );

    if (response.status == 200) {
      this.jurisdiction = response.data.data;
      this.loading = false;
    }
  }

  async save(): Promise<void> {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      if (this.isCreate) {
        await this.create();
      } else {
        await this.update();
      }
    }
  }

  async update(): Promise<void> {
    this.saving = true;

    const response = await this.$http.put(
      `${this.endpoint.jurisdiction.update}/${this.$route.params.id}`,
      this.jurisdiction
    );

    if (response.status == 200) {
      this.saving = false;

      this.setSnackbar({
        show: true,
        message: 'Jurisdiction update',
        color: 'success',
      });

      this.$router.push({ name: 'Jurisdictions' });
    } else {
      this.saving = false;
      console.log('erro...', response);
    }
  }

  async create(): Promise<void> {
    this.saving = true;

    const response = await this.$http.post(
      this.endpoint.jurisdiction.create,
      this.jurisdiction
    );

    if (response.status == 200) {
      this.saving = false;

      this.setSnackbar({
        show: true,
        message: 'Jurisdiction saved',
        color: 'success',
      });

      this.$router.push({ name: 'Jurisdictions' });
    }

    if (response.status != 200) {
      this.saving = false;
    }
  }

  goToIndex(): string {
    return `/${this.$route.meta?.index}`;
  }
}
